import { render, staticRenderFns } from "./NewLicenseForm.vue?vue&type=template&id=2f797783&scoped=true&"
import script from "./NewLicenseForm.vue?vue&type=script&lang=ts&"
export * from "./NewLicenseForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f797783",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VFileInput,VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f797783')) {
      api.createRecord('2f797783', component.options)
    } else {
      api.reload('2f797783', component.options)
    }
    module.hot.accept("./NewLicenseForm.vue?vue&type=template&id=2f797783&scoped=true&", function () {
      api.rerender('2f797783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/NewLicenseForm.vue"
export default component.exports